/* eslint-disable react/jsx-no-target-blank */
import LazyLoad from "react-lazyload";

import { Autoplay, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";

import Img from "components/atoms/Img";
import Title from "components/atoms/Title";

export default function AnyIndustry({ data }) {
  return (
    <div className="container">
      <div className="py-[100px] ">
        <Title
          text="Company Registration For Any Industry"
          className="bbc-title mb-6 text-center text-white"
        />
        <p className="m-auto w-4/5 text-center text-white">
          Hong Kong has plenty to offer in terms of business opportunities.
          Let&apos;s take a look at what some of the prominent prospects you can
          look forward to below:
        </p>
        <div className="row hidden lg:flex">
          {data &&
            data.map((item, index) => (
              <div key={index} className={"mt-10 lg:col-4"}>
                <div className="h-full rounded-3xl bg-white p-7">
                  <Img
                    src={`/assets/icons/${item.icon}`}
                    alt={item.title}
                    width={48}
                    height={48}
                    className="h-12 w-12"
                    wrapper={{
                      className:
                        "bg-bbc-brand-100 rounded-3xl p-4 inline-block mb-4",
                    }}
                  />
                  <p className="mb-4 text-lg font-semibold text-bbc-brand-700">
                    {item.title}
                  </p>
                  <p className="">{item.description}</p>
                  {item.link && (
                    <a
                      className="mt-1 inline-block font-medium text-bbc-brand-500"
                      href={item.link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.link.text}
                    </a>
                  )}
                </div>
              </div>
            ))}
        </div>
        <div className="block lg:hidden">
          <LazyLoad>
            <Swiper
              loop
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              className="mySwiper "
              modules={[Pagination, Autoplay]}
              pagination={{
                el: ".hk-slide-pagination",
                clickable: true,
                bulletClass:
                  "transition-all duration-300 ease-in-out relative inline-block cursor-pointer mx-1 w-2.5 h-2.5 rounded-full bg-white",
                bulletActiveClass: "bg-bbc-secondary-100",
              }}
            >
              {data &&
                data.map((item, index) => (
                  <SwiperSlide key={index} className=" h-auto p-4">
                    <div className="h-full rounded-3xl bg-white p-7">
                      <Img
                        src={`/assets/icons/${item.icon}`}
                        alt={item.title}
                        width={48}
                        height={48}
                        className="h-12 w-12"
                        wrapper={{
                          className:
                            "bg-bbc-brand-100 rounded-3xl p-4 inline-block mb-4",
                        }}
                      />
                      <p className="mb-4 text-lg font-semibold text-bbc-brand-700">
                        {item.title}
                      </p>
                      <p className="">{item.description}</p>
                      {item.link && (
                        <a
                          className="mt-1 inline-block font-medium text-bbc-brand-500"
                          href={item.link.href}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.link.text}
                        </a>
                      )}
                    </div>
                  </SwiperSlide>
                ))}
            </Swiper>
          </LazyLoad>
          <div className={"hk-slide-pagination text-center"}></div>
        </div>
      </div>
    </div>
  );
}
